import * as React from "react";
import { observer } from "mobx-react";
import { useContext } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { AnnotatedFormItem } from "./AnnotatedFormItem";
import { Input } from "antd";

export const NameRomanFormItem = observer(() => {
  const store = useContext(ContactViewStoreContext);

  return (
    <AnnotatedFormItem label="ローマ字表記" annotation="">
      <Input
        value={store.nameRoman}
        placeholder="SHOTA & MISAKI"
        onChange={(e) => {
          store.nameRoman = e.target.value;
        }}
      />
    </AnnotatedFormItem>
  );
});
